<ng-container *ngIf="membership.unlinked_customers.length > 0">
  <div class="alert alert-info">
    This membership has outstanding unlinked members. Link those members before modifying the membership.
  </div>
</ng-container>

<ng-container *ngIf="membership.unlinked_customers.length === 0">
  <div class="alert alert-info">
    The chosen member will be removed on the next bill date. The membership's price will be updated at that time to reflect the new set of members.
  </div>

  <select class="custom-select" [(ngModel)]="selectedMember">
    <option [ngValue]="null" disabled class="disabled">
      Select member to remove
    </option>
    <option *ngFor="let member of availableMembers()" [ngValue]="member">
      {{ member.first_name }} {{ member.last_name }}
    </option>
  </select>

  <p *ngIf="selectedMember" class="mb-0 mt-3">
    Selected Member:
    <b>{{ selectedMember.first_name }} {{ selectedMember.last_name }}</b>
  </p>
</ng-container>

<div class="alert alert-danger mt-3 mb-0" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
